<script>
import Layout from "@layouts/form";
import Contrato from "@forms/Contrato";

export default {
  page: {
    title: "Detalhes | Contrato"
  },
  components: {
    Layout,
    Contrato
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    clientesInativo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Contrato",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Contrato",
          href: "/Contrato"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Contrato :editable="editable" :clientesInativo="clientesInativo"></Contrato>
    </div>
  </Layout>
</template>
